import { Component, Inject, Input, OnDestroy, OnInit } from '@angular/core';
import {
  MatDialog,
  MatDialogConfig,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { PageEvent } from '@angular/material/paginator';
import { RelatedContentDataSource } from '../../services/related-content-data-source';
import { RelatedContentApiService } from '../../services/related-content-api-service';
import { RelatedContentAdd } from '../add/component';

@Component({
    selector: 'related-content-dialog',
    templateUrl: 'component.html',
    styleUrls: ['component.scss'],
    standalone: false
})
export class RelatedContentList implements OnInit, OnDestroy {
  private Subscriptions: Subscription[] = [];

  public DataSource = new RelatedContentDataSource(
    this.RelatedContentApi,
    'listing-admin',
    this.data.listingId
  );
  public loading: boolean;
  public RelatedContent;
  public PageEvent: PageEvent;
  public listingTitle;

  public displayedColumns = ['id', 'title', 'actions'];

  constructor(
    private dialog: MatDialog,
    private RelatedContentApi: RelatedContentApiService,
    @Inject(MAT_DIALOG_DATA) private readonly data: any
  ) {}

  async ngOnInit() {
    this.DataSource.connect().value;
    this.listingTitle = this.data.listingTitle;
    await this.DataSource.loadWithPageEvent();

    this.Subscriptions.push(
      this.DataSource.loading.subscribe((_loading) => (this.loading = _loading))
    );

    this.Subscriptions.push(
      this.DataSource.connect().subscribe(
        (_RelatedContent) => (this.RelatedContent = _RelatedContent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.PageEvent.subscribe(
        (_PageEvent) => (this.PageEvent = _PageEvent)
      )
    );
    this.Subscriptions.push(
      this.DataSource.filter.subscribe(
        (filter) => filter && this.DataSource.loadWithPageEvent(this.PageEvent)
      )
    );
  }

  public deleteRelatedContent(RelatedContent) {
    confirm('Are you sure you want to delete: ' + RelatedContent.title) &&
      this.DataSource.delete(RelatedContent, this.data.listingId);
  }
  public addRelatedContent() {
    const config = new MatDialogConfig();
    
    config.disableClose = true;
    config.data = {
      listingId: this.data.listingId || null,
      dataSource: this.DataSource,
    };
    this.dialog.open(RelatedContentAdd, config);
  }

  ngOnDestroy() {
    this.Subscriptions.forEach((Subscription) => Subscription.unsubscribe());
  }
}
